import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../app-config';

@Injectable({
  providedIn: 'root'
})
export class SchoolInvitesService {
  constructor(
    private httpClient: HttpClient,
    private apiUrl: AppConfig,
  ) { }

  public getSchoolInvitesRequestAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.schoolInvitesAPI, { params: filterData });
  }
  public getSchoolInvitesHistoryAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.schoolInvitesHistoryAPI, { params: filterData });
  }
  public inviteActionAPI = ({ action, ...data }: any): Observable<any> => {
    const endpoint = `${this.apiUrl.teacherApiURL.inviteActionAPI}-${action}/`;
    return this.httpClient.post<any>(endpoint, data);
  }
}